import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function GymPartnerBookingPage() {
  const [slots, setSlots]             = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(true);
  const [form, setForm]               = useState({ first_name: "", gym_name: "", phone: "", slot: "" });
  const [submitting, setSubmitting]   = useState(false);
  const [done, setDone]               = useState(false);
  const [error, setError]             = useState("");

  useEffect(() => {
    document.title = "Book a Call — GymPartnerAI";
    axios.get(`${API}/gympartner/availability`)
      .then(r => { setSlots(r.data.slots || []); setLoadingSlots(false); })
      .catch(() => setLoadingSlots(false));
  }, []);

  const handleSubmit = async () => {
    setError("");
    if (!form.first_name || !form.phone || !form.slot) { setError("Please fill in all fields and select a time."); return; }
    setSubmitting(true);
    try {
      await axios.post(`${API}/gympartner/booking`, {
        first_name: form.first_name,
        gym_name: form.gym_name,
        phone: form.phone,
        slot_datetime: form.slot,
        source: "sms_booking_page",
      });
      setDone(true);
    } catch (e) {
      setError(e.response?.data?.detail || "This slot was just taken — please pick another time.");
    }
    setSubmitting(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#F0F7FF", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px 16px", fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: 20, maxWidth: 460, width: "100%", overflow: "hidden", boxShadow: "0 8px 40px rgba(37,99,235,0.12)" }}>
        {/* Blue header */}
        <div style={{ background: "linear-gradient(135deg, #1D4ED8, #2563EB)", padding: "28px 28px 24px" }}>
          <div style={{ fontWeight: 900, fontSize: 18, color: "#fff", marginBottom: 6 }}>GymPartnerAI</div>
          <h1 style={{ fontSize: 22, fontWeight: 900, color: "#fff", margin: "0 0 6px", lineHeight: 1.2 }}>
            Book Your 30-Min Call with Ron K.
          </h1>
          <p style={{ color: "rgba(255,255,255,0.85)", fontSize: 14, margin: 0 }}>
            See the platform live. No pressure, no commitment — just a real look at what GymPartnerAI can do for your gym.
          </p>
        </div>

        <div style={{ padding: "24px 28px 28px" }}>
          {done ? (
            <div style={{ textAlign: "center", padding: "16px 0" }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
              <h2 style={{ fontSize: 20, fontWeight: 900, color: "#1E40AF", marginBottom: 8 }}>Call Confirmed!</h2>
              <p style={{ color: "#475569", fontSize: 15, lineHeight: 1.6 }}>
                Ron K. will call you at the time you selected. You'll receive a text confirmation shortly.
              </p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {[
                { key: "first_name", placeholder: "First Name", type: "text" },
                { key: "gym_name",   placeholder: "Gym / Studio Name", type: "text" },
                { key: "phone",      placeholder: "Phone Number", type: "tel" },
              ].map(f => (
                <input key={f.key} type={f.type} placeholder={f.placeholder} value={form[f.key]}
                  onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))}
                  style={{ border: "1.5px solid #BFDBFE", borderRadius: 10, padding: "13px 14px", fontSize: 15, color: "#1E293B", outline: "none", background: "#F8FAFF" }}
                />
              ))}
              <div>
                <label style={{ fontSize: 13, fontWeight: 700, color: "#475569", display: "block", marginBottom: 6 }}>
                  Select an Available Time
                </label>
                {loadingSlots ? (
                  <p style={{ color: "#94A3B8", fontSize: 14 }}>Loading available times…</p>
                ) : slots.length === 0 ? (
                  <p style={{ color: "#94A3B8", fontSize: 14 }}>No slots currently available. Please check back soon.</p>
                ) : (
                  <select value={form.slot} onChange={e => setForm(p => ({ ...p, slot: e.target.value }))}
                    style={{ width: "100%", border: "1.5px solid #BFDBFE", borderRadius: 10, padding: "13px 14px", fontSize: 15, color: "#1E293B", background: "#F8FAFF", outline: "none" }}>
                    <option value="">Choose a time slot…</option>
                    {slots.map(s => <option key={s.datetime_iso} value={s.datetime_iso}>{s.display}</option>)}
                  </select>
                )}
              </div>
              {error && (
                <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#DC2626" }}>
                  {error}
                </div>
              )}
              <button onClick={handleSubmit}
                disabled={submitting || !form.first_name || !form.phone || !form.slot}
                style={{
                  background: (submitting || !form.first_name || !form.phone || !form.slot) ? "#93C5FD" : "#2563EB",
                  color: "#fff", border: "none", borderRadius: 10, padding: "15px 0",
                  fontSize: 16, fontWeight: 900,
                  cursor: (submitting || !form.first_name || !form.phone || !form.slot) ? "default" : "pointer",
                  transition: "all 0.15s",
                }}
              >
                {submitting ? "Confirming…" : "Confirm My Call →"}
              </button>
              <p style={{ fontSize: 11, color: "#94A3B8", textAlign: "center", margin: 0 }}>
                By submitting you agree to receive SMS updates. Reply STOP to opt out.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
